import "./styles/globals.css";
import "@sendbird/uikit-react/dist/index.css";

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { PrivyProvider } from "@privy-io/react-auth";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

import { Buffer } from "buffer";

// Ref: https://stackoverflow.com/questions/68707553/uncaught-referenceerror-buffer-is-not-defined
// @ts-ignore
window.Buffer = Buffer;

// This method will be passed to the PrivyProvider as a callback
// that runs after successful login.
const handleLogin = (user: any) => {
  console.log(`User ${user.id} logged in!`);
};
let deferredPrompt: any;
ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <PrivyProvider
        appId={process.env.REACT_APP_PRIVY_APP_ID!}
        onSuccess={handleLogin}
        config={{
          loginMethods: ["sms", "twitter"],
          appearance: {
            theme: "dark",
            accentColor: "#EC53B0",
            logo: "/images/fantech-logo.png",
            showWalletLoginFirst: false,
          },
        }}
      >
        <App />
      </PrivyProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
serviceWorkerRegistration.register();
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  // Store the event for later use
  deferredPrompt = e;
  // Display your custom install button or message here
  showInstallButton();
});

function showInstallButton() {
  const installButton = document.getElementById("install-button");
  if (installButton) {
    installButton.style.display = "block";

    installButton.addEventListener("click", () => {
      // Show the browser's installation prompt
      deferredPrompt.prompt();

      // Wait for the user's choice
      deferredPrompt.userChoice.then((choiceResult: any) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the installation");
        } else {
          console.log("User dismissed the installation");
        }
        // Clear the deferred prompt
        deferredPrompt = null;
      });
    });
  }
}
